export default "\n{% block sw_cms_block_form %}\n<div class=\"sw-cms-block-form\">\n    <slot name=\"content\"></slot>\n</div>\n{% endblock %}\n";